import React, { useContext } from 'react';
import { BehaviorSubject } from 'rxjs';

import { useBreakpointMatch } from 'src/hooks/useBreakpoint';
import { AggregationSelections, MappedAggregations } from 'src/components/CategoryListingPage/utils/cleanAggregations';
import { FilterModalContext } from 'src/components/CategoryListingPage/FilterModalContext';
import { Button } from 'src/components/Button/Button';
import { ProductListQueryContext } from 'src/components/CategoryListingPage/ProductListQueryProvider';

import { LayeredNavLayout } from './LayeredNavLayout';
import { AggregationList } from './AggregationList';
import classes from './LayeredNav.scss';

export const EMPTY_ARR = [];

type LayeredNavProps = {
    currentFilters: React.ReactNode;
    mappedAggregations: MappedAggregations;
    onChange: (checked: boolean, code: string, label: string) => void;
    selections: BehaviorSubject<AggregationSelections>;
};

export function LayeredNav(props: LayeredNavProps) {
    const { pageInfo } = useContext(ProductListQueryContext);
    const { isMob } = useBreakpointMatch();
    const { closeFilter } = useContext(FilterModalContext);
    const resultsText = pageInfo.total_count > 1 ? 'results' : 'result';
    const viewResultsText = `View ${pageInfo.total_count} ${resultsText}`;

    return (
        <div>
            <LayeredNavLayout
                selections={
                    <AggregationList
                        current={props.currentFilters}
                        selection$={props.selections}
                        isMob={isMob}
                        onChange={props.onChange}
                    />
                }
                actions={
                    <Button variant="primary" className={classes.filterAction} onClick={() => closeFilter()}>
                        {viewResultsText}
                    </Button>
                }
            />
        </div>
    );
}
